

import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import { Col, Row, Button, Input } from 'reactstrap'
import DepartmentTable from './DepartmentTable';
import { addDepartment, getDepartments } from 'store/actions';
import CreateDepartment from './CreateDepartment';
import Breadcrumb from 'components/Common/Breadcrumb2';

const DepartmentList = () => {
    // const [selectedGroup, setselectedGroup] = useState(null);
    const [isOpen,setIsOpen] = useState(false);
    const navigate = useNavigate();
    
    const dispatch = useDispatch();
    const departments = useSelector((state) => state.Department.departments);
    const loading = useSelector((state) => state.Department.loading);
    const error = useSelector((state) => state.Department.error);

    const permissions = JSON.parse(localStorage?.getItem('permissions'));

    // Dispatch action to fetch catalog items when component mounts
    useEffect(() => {
        if(loading)return;
        dispatch(getDepartments()); // Dispatch the action to fetch catalog items
    }, [dispatch]);

    const handleSelectGroup = (selectedOption) => {
        setselectedGroup(selectedOption);
    }

    const handleSubmit = (data)=>{
        dispatch(addDepartment(data));
    }

    const handleClose = ()=>{
        setIsOpen(false)
    }

    return (
        <>
        <CreateDepartment visible={isOpen}  onSubmit={handleSubmit} handleClose={handleClose} />
        <div className='page-content container-fluid'>
            <div className='d-flex justify-content-between align-items-center  mx-3'>
                <Breadcrumb title="Departments" breadcrumbItems={[{ title: "Dashboard", link: `/dashboard` }, { title: "Departments", link: '#' }]} />
                {permissions?.map(item=>item?.permissionName)?.includes("Add Departments") && <Button className='bg-primary text-white d-flex justify-content-center gap-1 align-items-center' onClick={() => setIsOpen(true)}>
                    <i className='ti-plus'></i> Add New
                </Button>}
            </div>

            <DepartmentTable loading={loading} List={departments?.Data}/>
        </div>
        </>
    )
}

export default DepartmentList;
